import { render, staticRenderFns } from "./AddPurchaseOrderModal.vue?vue&type=template&id=2b5388cb"
import script from "./AddPurchaseOrderModal.vue?vue&type=script&lang=js"
export * from "./AddPurchaseOrderModal.vue?vue&type=script&lang=js"
import style0 from "./AddPurchaseOrderModal.vue?vue&type=style&index=0&id=2b5388cb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports